import { Fragment } from 'react';

export default function MediaDashboard() {
    return (
        <Fragment>
            <div className="page-route-body">
                <div className="main-content-title">数据总览</div>
                <div className="main-content-body">MediaDashboard</div>
            </div>

            <div className="page-route-body">
                <div className="main-content-title">功能导航</div>
                <div className="main-content-body"></div>
            </div>
        </Fragment>
    );
}
